"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINToggle = void 0;
var react_1 = __importDefault(require("react"));
var PropTypes = __importStar(require("prop-types"));
function PINToggle(_a) {
    var checked = _a.checked, onChange = _a.onChange, className = _a.className, inputAttributes = _a.inputAttributes;
    return (react_1.default.createElement("label", { className: "pintoggle switch " + className },
        react_1.default.createElement("input", __assign({ type: "checkbox", 
            // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
            onChange: function (e) { return onChange(e.target.checked); }, checked: checked }, (inputAttributes || {}), { readOnly: true })),
        react_1.default.createElement("span", { className: "slider round" })));
}
exports.PINToggle = PINToggle;
PINToggle.propTypes = {
    className: PropTypes.string,
    onChange: PropTypes.func,
    checked: PropTypes.bool,
    inputAttributes: PropTypes.object,
};
//# sourceMappingURL=PINToggle.js.map